var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRupeeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    role: "presentation",
    className: "IconBase_m_Qax_Y IconBase_root_U5LTW CurrencyIcon_m_ykDmf CurrencyIcon_noPadding_DFLlc",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_645_10790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.76 9.935A7.999 7.999 0 11.24 6.065a7.999 7.999 0 0115.521 3.87z",
    fill: "#006822"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.21 6.85l.249-.877H9.45a2.136 2.136 0 00-.242-.688 1.781 1.781 0 00-.117-.18l1.118.006.252-.885H5.814l-.26.945h1.35c.504 0 .875.117 1.112.351.127.127.22.277.28.451H5.803l-.248.878h2.77c-.028.11-.07.21-.125.301-.113.185-.28.326-.497.423a1.959 1.959 0 01-.799.146h-1.26l.007.692L8.193 11.5H9.49v-.06L7.167 8.594l.032-.007c.547-.033.988-.148 1.324-.344.337-.197.582-.451.736-.764a2.21 2.21 0 00.198-.628h.753z",
    fill: "#ff5d00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_645_10790"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 -.001)",
    d: "M0 0h16v16.002H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupeeIcon);
export default __webpack_public_path__ + "static/media/rupee-icon.8d3c7494a23f952b243a42d6f6f5ef09.svg";
export { ForwardRef as ReactComponent };